var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPass5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon-pass-5_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-pass-5_1",
    "data-name": "Icon-pass-5 \\u2013 1",
    clipPath: "url(#clip-Icon-pass-5_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-pass-5",
    transform: "translate(-951.486 -375.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M3157.245-13418.516h24.648",
    transform: "translate(-2204.578 13804)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-play-arrow",
    "data-name": "Icon material-play-arrow",
    d: "M12,7.5l1.109,5.48L12,18.46l8.611-5.48Z",
    transform: "translate(959.875 372.503)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M3189.4-13425.318v10",
    transform: "translate(-2221.267 13805.803)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M3189.4-13425.318v10",
    transform: "translate(-2224.49 13805.803)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M3189.4-13425.318v10",
    transform: "translate(-2227.711 13805.803)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M3189.4-13425.318v10",
    transform: "translate(-2230.934 13805.803)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M3189.4-13425.318v10",
    transform: "translate(-2234.333 13805.803)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass5);
export default __webpack_public_path__ + "static/media/pass-5.89fa4ab78051d35b573f3b5db90ebe4b.svg";
export { ForwardRef as ReactComponent };